export class ZeroEtlTargetTablesSort {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "field",
            "baseName": "field",
            "type": "ZeroEtlTargetTablesSortField",
            "format": ""
        },
        {
            "name": "order",
            "baseName": "order",
            "type": "SortOrder",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ZeroEtlTargetTablesSort.attributeTypeMap;
    }
    constructor() {
    }
}
